import { Link } from "react-router-dom";

export const ORC_STATUS = { em_elaboracao: "Em elaboração", concluido: "Concluído", superado: "Superado", cancelado: "Cancelado" };
export const ORC_COR = { em_elaboracao: "#2563EB", concluido: "#059669", superado: "#A1A1AA", cancelado: "#DC2626" };
export const PROP_STATUS = { elaborada: "Elaborada", enviada: "Enviada", vencedora: "Vencedora", perdida: "Perdida", cancelada: "Cancelada" };
export const PROP_EVENTO = { ...PROP_STATUS, reaberta: "Reaberta (voltou para elaborada)", planilha_atualizada: "Planilha atualizada", contrato_gerado: "Contrato gerado" };
export const PROP_COR = { elaborada: "#78716C", enviada: "#D97706", vencedora: "#059669", perdida: "#DC2626", cancelada: "#A1A1AA" };

export const Pill = ({ label, cor, testid }) => (
  <span data-testid={testid} style={{ padding: "2px 8px", borderRadius: 999, fontSize: "0.68rem", fontWeight: 700, color: "#fff", background: cor || "#71717A", textTransform: "uppercase", letterSpacing: "0.04em", whiteSpace: "nowrap" }}>{label}</span>
);
export const StatusOrcamento = ({ status }) => <Pill label={ORC_STATUS[status] || status} cor={ORC_COR[status]} testid="orcamento-status" />;
export const StatusProposta = ({ status }) => <Pill label={PROP_STATUS[status] || status} cor={PROP_COR[status]} testid="proposta-status" />;

export const F = ({ label, children, full }) => <div style={{ gridColumn: full ? "1 / -1" : undefined }}><div className="label">{label}</div>{children}</div>;

export function Funil({ oportunidadeId, orcamentoId, propostaId, contratoId, contratoNumero, orcamentoNumero, propostaNumero, oportunidadeTitulo }) {
  const Item = ({ to, label, val, testid }) => (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: "0.75rem" }} data-testid={testid}>
      <span style={{ color: "#71717A" }}>{label}</span>
      {to ? <Link to={to} className="font-mono font-semibold" style={{ color: "#0A0A0A", textDecoration: "underline" }}>{val}</Link> : <span style={{ color: "#A1A1AA" }}>—</span>}
    </span>
  );
  return (
    <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center" }} data-testid="funil-comercial">
      <Item label="Oportunidade" to={oportunidadeId && `/licitacoes?id=${oportunidadeId}`} val={oportunidadeTitulo || "ver"} testid="funil-oportunidade" />
      <span style={{ color: "#D4D4D8" }}>›</span>
      <Item label="Orçamento" to={orcamentoId && `/orcamentos/${orcamentoId}`} val={orcamentoNumero || "ver"} testid="funil-orcamento" />
      <span style={{ color: "#D4D4D8" }}>›</span>
      <Item label="Proposta" to={propostaId && `/propostas/${propostaId}`} val={propostaNumero || "ver"} testid="funil-proposta" />
      <span style={{ color: "#D4D4D8" }}>›</span>
      <Item label="Contrato" to={contratoId && `/contratos/${contratoId}`} val={contratoNumero || "ver"} testid="funil-contrato" />
    </div>
  );
}
